import { Resources } from "../../../data/Resources";

export enum CreatableEventEntryType {
  WEEKLY_TIP = Resources.WEEKLY_TIP
}
